import { useMutation } from '@tanstack/react-query';

import { RiskAssessmentTemplatesApi } from 'api/RiskAssessmentTemplatesApi';
import { useFiRiskAssessmentCache } from 'tanstack-hooks/fi-risk-assessments/risk-assessments-cache';
import { RISK_ASSESSMENT_TEMPLATES_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function usePublishRiskAssessmentTemplate() {
  const riskAssessmentTemplatesApi = new RiskAssessmentTemplatesApi();
  const { userBankId } = useUser();
  const { invalidateRiskAssessmentTemplates } = useFiRiskAssessmentCache();

  const { mutateAsync: publishRiskAssessmentTemplate, isPending: isPublishingRiskAssessmentTemplate } =
    useMutation({
      mutationKey: [RISK_ASSESSMENT_TEMPLATES_KEY, 'publish'],
      mutationFn: (id: string) => riskAssessmentTemplatesApi.publishRiskAssessmentTemplate(userBankId, id),
      onSuccess: () => {
        invalidateRiskAssessmentTemplates();
      },
      meta: {
        snackbarSuccessMessage: 'Template published.',
        snackbarErrorMessage: 'There was an issue publishing the template. Please contact support.'
      }
    });

  return { publishRiskAssessmentTemplate, isPublishingRiskAssessmentTemplate };
}
